const KEYS = {
  favorites: 'bloom-pose:favorites',
  checklist: 'bloom-pose:checklist',
};

function read(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function write(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export const store = {
  getFavorites() {
    return new Set(read(KEYS.favorites, []));
  },

  toggleFavorite(id) {
    const set = this.getFavorites();
    if (set.has(id)) set.delete(id);
    else set.add(id);
    write(KEYS.favorites, [...set]);
    return set;
  },

  isFavorite(id) {
    return this.getFavorites().has(id);
  },

  getChecklist() {
    return read(KEYS.checklist, {});
  },

  setChecklistIds(ids) {
    const prev = this.getChecklist();
    const next = {};
    ids.forEach((id) => {
      next[id] = Boolean(prev[id]);
    });
    write(KEYS.checklist, next);
    return next;
  },

  toggleChecklistDone(id) {
    const map = this.getChecklist();
    if (!(id in map)) map[id] = false;
    map[id] = !map[id];
    write(KEYS.checklist, map);
    return map;
  },

  addToChecklist(id) {
    const map = this.getChecklist();
    if (!(id in map)) {
      map[id] = false;
      write(KEYS.checklist, map);
    }
    return map;
  },

  removeFromChecklist(id) {
    const map = this.getChecklist();
    delete map[id];
    write(KEYS.checklist, map);
    return map;
  },

  clearChecklist() {
    write(KEYS.checklist, {});
    return {};
  },
};
